/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BucketModelDto } from '../../models/bucket-model-dto';

export interface AdminControllerGetBuckets$Params {
}

export function adminControllerGetBuckets(http: HttpClient, rootUrl: string, params?: AdminControllerGetBuckets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BucketModelDto>>> {
  const rb = new RequestBuilder(rootUrl, adminControllerGetBuckets.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BucketModelDto>>;
    })
  );
}

adminControllerGetBuckets.PATH = '/admin/buckets';
